import i18next from 'i18next';

const translatorFactory = (namespace, lng = null) => i18next.getFixedT(lng, namespace);

export default translatorFactory;
